export default __webpack_public_path__ + "static/media/Background 5_00051.795610ed.png";